import block from '@/mixins/block'
import RAF from '@/js/utils/raf'
import normalizeWheel from 'normalize-wheel'

const IMAGE_MARGIN = 20
const SPEED = 0.75

export default {
  name: 'block_grid',
  mixins: [block],
  data () {
    return {
      needIntersection: true,
      imagesLoaded: 0,
      scrollSpeed: 0,
      scrollSpeedTarget: 0,
      initialized: false,
      imageClicked: false
    }
  },
  mounted () {
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
    window.addEventListener('resize', () => {
      this.init()
    })

    RAF.suscribe('block-grid', this.update.bind(this))
    document.addEventListener('mousewheel', (event) => {
      const normalized = normalizeWheel(event)
      this.scrollSpeedTarget = Math.abs(normalized.pixelY) * 0.3
    })
  },
  methods: {
    imageLoaded () {
      this.imagesLoaded++
      if (this.imagesLoaded == this.$refs['grid-image'].length) {
        this.$nextTick(() => { this.init() })
      }
    },
    init () {
      let images = this.$refs['grid-image']
      let rows = [{ offset: [0, 0], images: [] }, { offset: [0, 0], images: [] }, { offset: [0, 0], images: [] }]
      for (let i = 0; i < images.length; i++) {
        rows[i % 3].images.push({ offset: 0, dom: images[i] })
      }

      this.rows = rows
      this.images = images
      this.imageWidth = this.$refs['grid-image'][0].offsetWidth
      this.imageHeight = this.$refs['grid-image'][0].offsetHeight

      rows[0].offset[1] = -(this.imageHeight + IMAGE_MARGIN)
      rows[2].offset[1] = this.imageHeight + IMAGE_MARGIN

      rows[0].offset[0] = 2.5 * (-(this.imageWidth + IMAGE_MARGIN) * images.length / 3) / rows[0].images.length
      rows[1].offset[0] = 2.5 * (-(this.imageWidth + IMAGE_MARGIN) * images.length / 3) / rows[0].images.length
      rows[2].offset[0] = 2.5 * (-(this.imageWidth + IMAGE_MARGIN) * images.length / 3) / rows[0].images.length

      for (let i = 0; i < this.rows.length; i++) {
        const row = this.rows[i]
        for (let j = 0; j < row.images.length; j++) {
          const img = row.images[j]
          img.offset = j * (this.imageWidth + IMAGE_MARGIN)
        }
      }

      this.update()
      this.initialized = true
    },
    setTranslate (dom, x, y, scale) {
      dom.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`
    },

    show () {
      this.$el.classList.remove('hidden')
    },
    hide () {
      this.$el.classList.add('hidden')
    },
    update () {
      if (this.initialized == false) { return }

      let tmp = this.scrollSpeed
      tmp *= 0.15
      this.scrollSpeed += tmp
      if (this.scrollSpeedTarget > 0.3) {
        this.scrollSpeedTarget = this.scrollSpeedTarget - 0.5
      }
      for (let i = 0; i < this.rows.length; i++) {
        const row = this.rows[i]
        for (let j = 0; j < row.images.length; j++) {
          const img = row.images[j]
          if (i % 2 == 0) {
            img.offset += SPEED + this.scrollSpeed
          } else {
            img.offset -= SPEED + this.scrollSpeed
          }
          if (img.offset < 0) {
            img.offset = (this.imageWidth + IMAGE_MARGIN) * row.images.length
          }
          if (img.offset > (this.imageWidth + IMAGE_MARGIN) * row.images.length) {
            img.offset = 0
          }
          if (!img.dom.classList.contains('clicked')) {
            this.setTranslate(img.dom, img.offset + row.offset[0], row.offset[1], 1)
          } else {
            img.dom.setAttribute('xPos', img.offset + row.offset[0])
            img.dom.setAttribute('yPos', row.offset[1])
            if (i % 2 == 0) {
              img.dom.setAttribute('way', 1)
            } else {
              img.dom.setAttribute('way', 1)
            }
          }
        }
      }
    },
    handleClick (e) {
      if (this.imageClicked) {
        TweenMax.to(this.imageClicked, 0.5, { rotation: 0,
          x: this.imageClicked.getAttribute('xPos') + this.imageClicked.getAttribute('way') * 60,
          y: this.imageClicked.getAttribute('yPos'),
          scale: 1,
          onComplete: () => {
            this.imageClicked.classList.remove('clicked')
            this.imageClicked.offsetParent.classList.remove('clicked')
            this.imageClicked = false
          } })
      } else {
        let el = e.srcElement
        this.imageClicked = el
        el.classList.add('clicked')
        el.offsetParent.classList.add('clicked')
        TweenMax.to(el, 0.5, { rotation: 15, x: 0, y: 0, z: 10, scale: 1.8, ease: Power2.easeOut })
      }
    }
  }
}
